import React from "react";
import Button from "../../../components/shared/buttons/button";
import useTranslator from "../../../hooks/useTranslator";
import { getTranslatedRoomName } from "../../../helpers/Utils";

const RoomCard = ({ roomDetails, handleView }) => {
  const { _t } = useTranslator();
  // console.log(roomDetails?.name);



  return (
    <div className="room_card">
      <div className="d-flex justify-content-between">
        <p className="m-0">{getTranslatedRoomName(roomDetails?.name,_t)}</p>
        <Button label={_t("view_data", "View Data")} size="small" onClick={handleView} />
      </div>
      <ul className="pb-0 mb-0">
        <li className="d-flex justify-content-between align-items-center">
          <p className="m-0 ">{_t("room_capacity", "Room Capacity")}</p>
          <span>{roomDetails.cases_capacity} {_t("cases", "Cases")}</span>
        </li>
        <li className="d-flex justify-content-between align-items-center">
          <p className="m-0 ">{_t("total_cases_entered", "Total Cases Entered")}</p>
          <span>{roomDetails.total_cases} {_t("cases", "Cases")}</span>
        </li>
        <li className="d-flex justify-content-between align-items-center">
          <p className="m-0 ">{_t("total_fruit_kg", "Total cases fruit entered in KG")}</p>
          <span>{roomDetails.total_fruit_kg}{_t("kg", "KG")}</span>
        </li>
        <li className="d-flex justify-content-between align-items-center">
          <p className="m-0 ">{_t("total_pallets_entered", "Total Pallets in the Room Entered")}</p>
          <span>{roomDetails.total_pallets}</span>
        </li>
      </ul>
    </div>
  );
};

export default RoomCard;
